import React from "react";
import withStyles from "react-jss";

const styles = (theme) => ({
	root: {
		paddingBottom: "10px",
	},
	channels: {
		marginTop: "20px",
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			minHeight: 0,
			flexWrap: "wrap",
			width: "100%",
			display: "flex",
			justifyContent: "space-between",
			marginBottom: "25px",
			paddingBottom: 0,
			alignItems: "flex-start",
		},
		channels: {
			marginTop: 0,
		},
	},
});

const Component = ({ classes, speedORtv, channels, price }) => {
	return (
		<div className={classes.root}>
			<div>{speedORtv}</div>
			{!!channels && <div className={classes.channels}>{channels}</div>}
			<div>{price}</div>
		</div>
	);
};

const PlanAHeader = withStyles(styles)(Component);
PlanAHeader.displayName = "PlanAHeader";

export default PlanAHeader;
